import { debugLocalStorage, compareAuthStateSize } from "./services/auth";

window.global ||=  window;

// Funzioni di debug disponibili in console per sviluppatori
if (import.meta.env.DEV) {
  (window as Window & {
    debugLocalStorage?: typeof debugLocalStorage;
    compareAuthStateSize?: typeof compareAuthStateSize;
  }).debugLocalStorage = debugLocalStorage;

  (window as Window & {
    debugLocalStorage?: typeof debugLocalStorage;
    compareAuthStateSize?: typeof compareAuthStateSize;
  }).compareAuthStateSize = compareAuthStateSize;
}

